<template>
  <div class="modal is-active cupon-form">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box new-ref">
        <h2>{{title}}</h2>

        <div class="notification is-danger"
         v-if="$store.state.cuponForm.error">
          <p>אירעה שגיאה בנסיון השמירה</p>
        </div>

        <div class="field">
          <label class="label">סוג קופון</label>
          <div class="select">
            <select v-model="fields.type">
              <option value="1">ימי מתנה</option>
              <option value="2">הנחה בתשלום ראשון למנוי חודשי</option>
              <option value="3">הנחה בתשלום ראשון למנוי שנתי</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">בתוקף עד</label>
          <div class="control">
            <datepicker v-model="fields.valid_until" placeholder="בתוקף עד"
            :language="he" input-class="input" :disabledDates="disabledDates"></datepicker>
          </div>
        </div>

        <div class="field">
          <label class="label">קוד קופון</label>
          <div class="control">
            <input class="input" type="text" placeholder="קוד קופון"
            v-model="fields.cupon">
          </div>
        </div>

        <div class="field">
          <label class="label">ימי מתנה \ הנחה בשקלים</label>
          <div class="control">
            <input class="input" type="text" placeholder="מספר ימי מתנה"
            v-model="fields.free_days">
          </div>
        </div>

        <div class="field">
          <label class="label">כמות</label>
          <div class="control">
            <input class="input" type="text" placeholder="כמות"
            v-model="fields.qty">
          </div>
        </div>

        <div class="field">
          <label class="label">שם חברה</label>
          <div class="control">
            <input class="input" type="text" placeholder="שם חברה"
            v-model="fields.company">
          </div>
        </div>

        <div class="has-text-left">
          <button class="button is-success"
          @click="saveCupon">שמור</button>
        </div>

      </div>
    </div>
    <button class="modal-close is-large" aria-label="close"
     @click="close"></button>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { he } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    Datepicker
  },

  data() {
    return {
      fields: {},
      he: he,
      disabledDates: {
        to: new Date()
      }
    };
  },

  computed: {
    title() {
      if (this.fields.mode === "new") {
        return "צור קופון חדש";
      }
      return "ערוך קופון";
    }
  },

  methods: {
    close() {
      this.$store.dispatch("closeCuponForm");
    },
    saveCupon() {
      this.$store.dispatch("saveCupon", this.fields);
    }
  },
  created() {
    this.fields = this.$store.state.cuponForm;
  }
};
</script>

<style lang="scss">
.cupon-form {
  .box {
    min-height: 440px;
  }

  .select {
    display: block;
    select {
      width: 100%;
    }
  }
}
</style>
